module.exports = __webpack_public_path__ + "img/LOGOSGPF256Prancheta 2.d8bf7882.png";